import React, { useState } from "react";
import { Link } from "react-router-dom";
import { db, auth } from "../firebaseConfig"; // 🔥 Ajout de auth
import { collection, addDoc } from "firebase/firestore";
import { motion } from "framer-motion";


const AddClothing = () => {
    const [formData, setFormData] = useState({
        type: "",
        color: "",
        season: "",
        occasions: [],
        image: null, // Contiendra l'image convertie en Base64
    });

    // Gestion des changements dans le formulaire
    const handleChange = async (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            setFormData((prevData) => ({
                ...prevData,
                occasions: checked
                    ? [...prevData.occasions, value]
                    : prevData.occasions.filter((item) => item !== value),
            }));
        } else if (type === "file") {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setFormData((prevData) => ({ ...prevData, image: reader.result })); // Stocke l'image en Base64
                };
                reader.readAsDataURL(file); // Convertit l'image en Base64
            }
        } else {
            setFormData((prevData) => ({ ...prevData, [name]: value }));
        }
    };

    // Sauvegarder les données dans Firestore
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!auth.currentUser) {
            alert("Vous devez être connecté pour ajouter un vêtement.");
            return;
        }

        try {
            await addDoc(collection(db, "clothes"), {
                ...formData,
                userId: auth.currentUser.uid, // Associe le vêtement au user connecté
            });

            alert("Vêtement ajouté avec succès !");
            setFormData({ type: "", color: "", season: "", occasions: [], image: null });
        } catch (error) {
            console.error("Erreur lors de l'ajout du vêtement :", error);
            alert("Erreur lors de l'ajout du vêtement. Veuillez réessayer.");
        }
    };


    return (
        <div className="flex justify-center items-center bg-gradient-to-r from-blue-500 via-purple-600 to-pink-600 min-h-screen">
            <motion.div
                className="w-full max-w-2xl bg-white p-8 rounded-3xl shadow-lg"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6 }}
            >
                <h1 className="text-3xl font-semibold text-center text-gray-900 mb-10">Ajouter un Vêtement</h1>
                <form className="space-y-8" onSubmit={handleSubmit}>
                    {/* Type de vêtement */}
                    <div className="space-y-2">
                        <label className="text-lg text-gray-700">Type de vêtement *</label>
                        <select
                            name="type"
                            className="w-full p-4 bg-gray-100 rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.type}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Sélectionner un type</option>
                            <option value="sweat">Sweat à capuche</option>
                            <option value="t-shirt">T-shirt</option>
                            <option value="pantalon">Pantalon</option>
                            <option value="robe">Robe</option>
                            <option value="veste">Veste</option>
                            <option value="chaussures">Chaussures</option>
                            <option value="accessoires">Accessoires</option>
                            <option value="manteau">Manteau</option>
                        </select>
                    </div>

                    {/* Couleur */}
                    <div className="space-y-2">
                        <label className="text-lg text-gray-700">Couleur</label>
                        <select
                            name="color"
                            className="w-full p-4 bg-gray-100 rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.color}
                            onChange={handleChange}
                        >
                            <option value="">Sélectionner une couleur</option>
                            <option value="bleu">Bleu pastel</option>
                            <option value="noir">Noir</option>
                            <option value="gris">Gris</option>
                            <option value="blanc">Blanc</option>
                            <option value="rouge">Rouge</option>
                            <option value="vert">Vert</option>
                            <option value="jaune">Jaune</option>
                            <option value="beige">Beige</option>
                            <option value="rose">Rose</option>
                            <option value="marron">Marron</option>
                            <option value="violet">Violet</option>
                        </select>
                    </div>

                    {/* Saison */}
                    <div className="space-y-2">
                        <label className="text-lg text-gray-700">Saison *</label>
                        <select
                            name="season"
                            className="w-full p-4 bg-gray-100 rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.season}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Sélectionner une saison</option>
                            <option value="ete">Été</option>
                            <option value="hiver">Hiver</option>
                            <option value="printemps">Printemps</option>
                            <option value="automne">Automne</option>
                            <option value="toutes">Toutes saisons</option>
                        </select>
                    </div>

                    {/* Image */}
                    <div className="space-y-2">
                        <label className="text-lg text-gray-700">Image</label>
                        <input
                            type="file"
                            name="image"
                            className="w-full p-4 bg-gray-100 rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={handleChange}
                        />
                        {formData.image && (
                            <div className="mt-6 flex justify-center">
                                <img
                                    src={formData.image} // Utilisation de Base64 directement
                                    alt="Aperçu"
                                    className="w-48 h-48 object-cover rounded-xl shadow-lg transform transition duration-500 hover:scale-105"
                                />
                            </div>
                        )}
                    </div>

                    {/* Boutons */}
                    <div className="flex justify-between space-x-4 mt-6">
                        <button
                            type="submit"
                            className="w-full bg-blue-600 text-white py-4 rounded-lg shadow-xl hover:bg-blue-700 transition duration-300"
                        >
                            Ajouter au dressing
                        </button>
                        <Link
                            to="/dressing"
                            className="w-full bg-gray-300 text-gray-700 py-4 rounded-lg shadow-xl hover:bg-gray-400 transition duration-300"
                        >
                            Voir mon dressing
                        </Link>
                    </div>
                </form>
            </motion.div>
        </div>
    );
};

export default AddClothing;
